import styled from "styled-components";
import { media } from "utils/style-utils";
import workflowBG from "images/valve.jpg";

const ResponsiveBackgroundContainer = styled.div`
  ${media.desktop`
    background: url('${workflowBG}');
    background-attachment: fixed;
    background-repeat: no-repeat;
    background-size: cover; `};

  ${media.touch`
    background: rgb(54,54,54);
    `};
`;

export default ResponsiveBackgroundContainer;



// WEBPACK FOOTER //
// ./src/pages/Workflow/ResponsiveBackgroundContainer.js